module.exports = __webpack_public_path__ + "img/code55.ce50112f.png";